import React, { useState } from "react";
import { Redirect, useParams } from "react-router-dom";
import config from "../../config/apiConfig";
import Logo from "../../icons/logo.jpg";
import "./PasswordReset.scss";

const PasswordReset: React.FC = () => {
    const { reset_token } = useParams<{ reset_token: string }>();
    const [error, setError] = useState("");
    const [isVerified, setIsVerified] = useState(false);
    const [password, setPassword] = useState("");

    function handleVerify(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
        e.preventDefault();
        const formData = new FormData();
        formData.append("reset_token", reset_token);
        formData.append("password", password);
        formData.append("token", config.token);
        formData.append("session-token", "AUTH");
        formData.append("device", "web");
        const requestOptions = {
            method: "POST",
            body: formData,
        };
        fetch(config.BASE_URL + "/idam/user/reset_password", requestOptions)
            .then((res) => res.json())
            .then((resp) => {
                if (resp.is_error) {
                    setError(resp.error_msg);
                } else {
                    setIsVerified(true);
                    setError(resp.info_msg);
                }
            });
    }

    return isVerified ? (
        <Redirect to="/login" />
    ) : (
        <div className="verify">
            <img src={Logo} />
            <h2>Please Enter Your New Password</h2>
            <form className="login__form" id="form" method="post">
                <input
                    type="password"
                    className="login__input"
                    style={{maxWidth:'100%'}}
                    placeholder="New Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                />
            </form>
            <button className="verify__btn" onClick={handleVerify}>
                Reset Password
            </button>
            <p style={{ color: "red" }}>{error}</p>
        </div>
    );
};

export default PasswordReset;
